import { IDataStorage } from '../internal/data-storage';
import { InternalTable } from '../internal/internal-table';
import { InternalIndex } from '@stockcare-storage/internal/internal-index';

export class Procedure implements IDataStorage {
  index: InternalIndex = new InternalIndex('Id', 'Id', true, false);
  tableDefinition: InternalTable = new InternalTable('Procedures', 'Id', true, [
    this.index
  ]);

  Id: number;
  ReferenceId: string;
  CreatedTime: Date;
  CreatedByUserId: string;
  Name: string;
  UpdatedTime: any;
  UpdatedByUserId: string;
  EndDate: Date;
  InstitutionId: string;
  StartDate: Date;

  static getTableDefinition(): InternalTable {
    return new Procedure().tableDefinition;
  }
}
